import { useQuery } from '@tanstack/react-query'
import { getCargaProfesor } from '../utils/api/asistencias'
import { useNotification } from '../context/NotificationManager/NotificationManager'

export const useCargaProfesor = ({ profesor, mes, enabled = true }) => {
  const notification = useNotification()
  const { data: carga = {} } = useQuery({
    queryKey: ['planificacion', 'carga-profesor', profesor, mes],
    enabled: enabled && !!profesor && !!mes,
    queryFn: () =>
      getCargaProfesor({ profesor, mes }).catch(err => {
        notification.error({
          title: 'Error al recuperar la carga del profesor',
          content: err
        })
        return {}
      })
  })
  return { carga }
}
